module.exports = __webpack_public_path__ + "static/media/Stage-b-c-f.4485140c.webp";